var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlankFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.76,
    height: 11.713,
    viewBox: "0 0 9.76 11.713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4f5b6d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M46.153,3.477a1.773,1.773,0,0,0-.366-.579L43.408.518a1.777,1.777,0,0,0-.579-.366A1.76,1.76,0,0,0,42.158,0h-4.88a.706.706,0,0,0-.518.213.706.706,0,0,0-.213.519V10.981a.729.729,0,0,0,.732.732h8.3a.729.729,0,0,0,.732-.732V4.148A1.76,1.76,0,0,0,46.153,3.477ZM42.4,1.037a.835.835,0,0,1,.313.168L45.1,3.592a.835.835,0,0,1,.168.313H42.4Zm2.928,9.7H37.522V.976h3.9V4.148a.729.729,0,0,0,.732.732H45.33Z",
    transform: "translate(-36.546 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankFile);
export default __webpack_public_path__ + "static/media/blank-file.1d035b14f3e3fe0ea55dcf6f1755edcb.svg";
export { ForwardRef as ReactComponent };